import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_gl_pref_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_gl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  property_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_gl_pref_RowClass
  implements bl_fi_gl_pref_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_gl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  property_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
